import React from 'react';
import { Box, SxProps } from '@mui/material';

interface PropVuLogoProps {
  sx?: SxProps;
}

const PropVuLogo: React.FC<PropVuLogoProps> = ({ sx }) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 360 144"
    sx={sx}>
    <defs>
      <linearGradient
        id="New_Gradient_Swatch_1"
        data-name="New Gradient Swatch 1"
        x1="64.15"
        y1="59.9"
        x2="76.18"
        y2="59.9"
        gradientUnits="userSpaceOnUse">
        <stop offset=".03" stopColor="#ff6e00" />
        <stop offset="1" stopColor="#f7403b" />
      </linearGradient>

      <linearGradient
        id="New_Gradient_Swatch_1-2"
        data-name="New Gradient Swatch 1"
        x1="84.47"
        x2="96.51"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-3"
        data-name="New Gradient Swatch 1"
        y1="79.69"
        y2="79.69"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-4"
        data-name="New Gradient Swatch 1"
        x1="84.47"
        y1="79.69"
        x2="96.51"
        y2="79.69"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-5"
        data-name="New Gradient Swatch 1"
        x1="73.29"
        y1="69.8"
        x2="87.37"
        y2="69.8"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-6"
        data-name="New Gradient Swatch 1"
        x1="52.23"
        y1="52.26"
        x2="72.39"
        y2="52.26"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-7"
        data-name="New Gradient Swatch 1"
        x1="88.45"
        y1="87.81"
        x2="107.28"
        y2="87.81"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-8"
        data-name="New Gradient Swatch 1"
        x1="52.23"
        y1="88.48"
        x2="72.39"
        y2="88.48"
        xlinkHref="#New_Gradient_Swatch_1"
      />
      <linearGradient
        id="New_Gradient_Swatch_1-9"
        data-name="New Gradient Swatch 1"
        x1="88.45"
        y1="52.92"
        x2="107.28"
        y2="52.92"
        xlinkHref="#New_Gradient_Swatch_1"
      />
    </defs>

    <path
      fill="#1a216e"
      d="M151.48,54.48c-2.46-1.24-5.41-1.86-8.86-1.86h-15.64v38.33h7.88v-10.2h7.71c3.49,0,6.46-.62,8.92-1.86,2.46-1.24,4.31-2.93,5.57-5.06,1.26-2.14,1.88-4.52,1.88-7.14s-.63-5.01-1.88-7.14c-1.26-2.14-3.11-3.83-5.57-5.06ZM148.53,71.89c-1.43,1.41-3.28,2.11-5.57,2.11h-8.1v-14.62h8.16c2.25,0,4.09.7,5.51,2.11,1.42,1.41,2.14,3.14,2.14,5.2s-.71,3.8-2.14,5.2Z"
    />
    <path
      fill="#1a216e"
      d="M171.7,67.02l-.39-.06c.11-1.52.11-2.76.11-4.27h-7.42v28.24h7.59v-14.62c0-4.22,2.19-6.75,6.3-6.75h2.7v-6.92c-.56-.11-1.07-.17-1.57-.17-2.98,0-5.74,1.35-7.31,4.56Z"
    />
    <path
      fill="#1a216e"
      d="M196.45,61.73c-8.66,0-14.62,6.36-14.62,15.07s5.96,15.02,14.62,15.02,14.62-6.36,14.62-15.07-5.96-15.02-14.62-15.02ZM196.45,85.02c-4.44,0-7.14-3.66-7.14-8.21s2.7-8.27,7.14-8.27,7.14,3.66,7.14,8.21-2.76,8.27-7.14,8.27Z"
    />
    <path
      fill="#1a216e"
      d="M232.28,62.07c-3.54,0-6.75,1.52-8.77,4.84l-.45-.11c.11-1.41.11-2.64.11-4.11h-7.42v40.1h7.59v-9.34c0-2.47,0-4.16-.28-6.52l.45-.11c1.97,3.26,4.84,4.78,8.55,4.78,7.71,0,12.66-6.41,12.66-14.74s-4.78-14.79-12.43-14.79ZM230.26,84.74c-4.33,0-7.09-3.26-7.09-7.93s2.7-7.99,7.09-7.99,6.92,3.49,6.92,7.99-2.7,7.93-6.92,7.93Z"
    />
    <polygon
      fill="#1a216e"
      points="262.09 79.79 251.86 52.62 242.97 52.62 258.38 90.93 265.75 90.93 281.22 52.62 272.84 52.62 262.09 79.79"
    />
    <path
      fill="#1a216e"
      d="M300.18,62.69v16.71c0,3.32-1.86,5.62-5.17,5.62s-5.23-2.31-5.23-5.62v-16.71h-7.54v17.04c0,7.59,5.06,12.15,12.77,12.15s12.77-4.56,12.77-12.21v-16.99h-7.59Z"
    />

    <g>
      <path
        fill="url(#New_Gradient_Swatch_1)"
        d="M64.15,58.22v6.94c0,.21.17.38.38.38h1.61c.21,0,.38-.17.38-.38v-6.94c0-.88.72-1.6,1.6-1.6h7.68c.21,0,.38-.17.38-.38v-1.61c0-.21-.17-.38-.38-.38h-7.68c-2.19,0-3.97,1.78-3.97,3.97Z"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-2)"
        d="M84.86,56.62h7.68c.88,0,1.6.72,1.6,1.6v6.94c0,.21.17.38.38.38h1.61c.21,0,.38-.17.38-.38v-6.94c0-2.19-1.78-3.97-3.97-3.97h-7.68c-.21,0-.38.17-.38.38v1.61c0,.21.17.38.38.38Z"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-3)"
        d="M75.8,82.97h-7.68c-.88,0-1.6-.72-1.6-1.6v-6.94c0-.21-.17-.38-.38-.38h-1.61c-.21,0-.38.17-.38.38v6.94c0,2.19,1.78,3.97,3.97,3.97h7.68c.21,0,.38-.17.38-.38v-1.61c0-.21-.17-.38-.38-.38Z"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-4)"
        d="M96.51,81.37v-6.94c0-.21-.17-.38-.38-.38h-1.61c-.21,0-.38.17-.38.38v6.94c0,.88-.72,1.6-1.6,1.6h-7.68c-.21,0-.38.17-.38.38v1.61c0,.21.17.38.38.38h7.68c2.19,0,3.97-1.78,3.97-3.97Z"
      />
      <polygon
        fill="url(#New_Gradient_Swatch_1-5)"
        points="87.37 68.49 81.67 68.49 81.67 62.54 78.99 62.54 78.99 68.49 73.29 68.49 73.29 71.05 78.99 71.05 78.99 77.05 81.67 77.05 81.67 71.05 87.37 71.05 87.37 68.49"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-6)"
        d="M55.12,49.26c0-1.95,1.58-3.53,3.53-3.53h13.73v-2.88s-13.73,0-13.73,0c-3.54,0-6.42,2.88-6.42,6.42v12.41h2.88s0-12.41,0-12.41Z"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-7)"
        d="M104.39,77.74v13.73c0,1.94-1.58,3.53-3.53,3.53h-12.42s0,2.89,0,2.89h12.41c3.54,0,6.42-2.88,6.42-6.42v-13.74s-2.89,0-2.89,0Z"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-8)"
        d="M58.65,95c-1.94,0-3.53-1.58-3.53-3.53v-12.42s-2.89,0-2.89,0v12.41c0,3.54,2.88,6.42,6.42,6.42h13.74s0-2.89,0-2.89h-13.73Z"
      />
      <path
        fill="url(#New_Gradient_Swatch_1-9)"
        d="M104.39,49.26v13.73h2.88s0-13.73,0-13.73c0-3.54-2.88-6.42-6.42-6.42h-12.41v2.88s12.41,0,12.41,0c1.95,0,3.53,1.58,3.53,3.53Z"
      />
    </g>
  </Box>
);

export default PropVuLogo;
